import { DEFAULT_COLOR, DEFAULT_LINE_WIDTH } from '@/lib/annotations/constants'

export default function useSocketStateSync({
  setLineWidth,
  setStroke,
}: {
  setLineWidth(width: number): void
  setStroke(color: number): void
}): DrawingObserver {
  return {
    setup(opts) {
      // update host's picker widget when the client receives the socket's persistent state on reconnect
      if (opts.strokeStyle) {
        setStroke(_stringToColor(opts.strokeStyle))
      }
      if (opts.lineWidth) {
        setLineWidth(opts.lineWidth)
      }
      // the only case for a null payload is when state:current is empty
      if (Object.keys(opts).length === 0) {
        setStroke(DEFAULT_COLOR)
        setLineWidth(DEFAULT_LINE_WIDTH)
      }
    },
  }
}

function _stringToColor(color: string) {
  return parseInt(color.replace('#', ''), 16)
}
